import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=00f33262&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00f33262')) {
      api.createRecord('00f33262', component.options)
    } else {
      api.reload('00f33262', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=00f33262&", function () {
      api.rerender('00f33262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/incident/handling/Index.vue"
export default component.exports